// @flow

import CompanyImage from './CompanyImage'
import { IMAGE_TYPES } from './CompanyImage.constants'

export { IMAGE_TYPES }

export default CompanyImage
